var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomChipsGroup',{attrs:{"title":"Necesidades Seleccionadas","disabled":"","no-background":"","no-wrap":"","object-text":_vm.keyText,"selected-items":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }